export default "__VITE_ASSET__CNJr$gV3__"